import Vue from "vue"

export default {
    namespaced: true,

    state: () => {
        return {
            primaryProvider: null,
            providers: [],
            responses: {},
            errors: {},
            excludedProviders: []
        }
    },

    mutations: {
        saveResponse(state, { providerKey, type, response }) {
            const providerResponses = getOrCreateResponseState(state, providerKey)
            providerResponses[type] = response
        },
        updatePaymentPlans(state, { providerKey, paymentPlans }) {
            const providerResponses = getOrCreateResponseState(state, providerKey)
            Vue.set(providerResponses, "paymentPlans", paymentPlans)
        },
        updateStipulations(state, { providerKey, stipulations }) {
            const providerResponses = getOrCreateResponseState(state, providerKey)
            Vue.set(providerResponses, "stipulations", stipulations)
        },
        updateStipulation(state, { providerKey, stipulation }) {
            const providerResponses = getOrCreateResponseState(state, providerKey)
            providerResponses.stipulations = (providerResponses.stipulations || []).map(s => {
                return s.id === stipulation.id ? stipulation : s
            })
        },
        updateProviders(state, providers) {
            state.providers = providers
        },
        updatePrimaryProvider(state, provider) {
            state.primaryProvider = provider
        },
        addError(state, { providerKey, errorType, error }){
            const providerErrors = getOrCreateErrorState(state, providerKey)
            providerErrors[errorType] = error
        },
        removeError(state, { providerKey, errorType }) {
            const providerErrors = getOrCreateErrorState(state, providerKey)
            delete providerErrors[errorType]
        },
        setExcludedProviders(state, providers) {
            state.excludedProviders = providers
        }
    },
}

function getOrCreateResponseState(state, providerKey) {
    let providerResponses = state.responses[providerKey]

    if (!providerResponses) {
        providerResponses = {}
    }

    Vue.set(state.responses, providerKey, providerResponses)

    return providerResponses
}

function getOrCreateErrorState(state, providerKey) {
    let providerErrors = state.errors[providerKey]

    if (!providerErrors) {
        providerErrors = {}
    }

    Vue.set(state.errors, providerKey, providerErrors)

    return providerErrors
}
